module.exports = flarum.reg.get('core', 'common/components/InfoTile');